/// <reference path="../../Common/Helpers/GridEditorBase.ts" />
namespace GeniuzPOS.InventoryReport {

    @Serenity.Decorators.registerClass()
    export class IcReport08DtEditor extends Serenity.Extensions.GridEditorBase<IcReport08DtRow> {
        protected getColumnsKey() { return "InventoryReport.IcReport08Dt"; }
        protected getDialogType() { return IcReport08DtDialog; }
        protected getLocalTextPrefix() { return IcReport08DtRow.localTextPrefix; }

        public qnNo: number;

        public myPassValue: string;        
        

        constructor(container: JQuery) {
            super(container);
        
        }      

        protected getButtons(): Serenity.ToolButton[] {
            var buttons = super.getButtons();
           
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
                       
            return buttons;
        }
    
        protected getSlickOptions() {
            var opt = super.getSlickOptions();
            opt.showFooterRow = true;
            return opt;
        }

        protected getViewOptions() {
            var opt = super.getViewOptions();
            opt.localSort = true;
            return opt;
        }

        protected usePager() {
            return false;
        }

    }
}

